import { Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import authService from "../Auth/AuthService";

export default function ResetPassword({ login, onSuccess }) {

  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState("");

  const handleChange = (e) => {

    const reset = e.target.value;
    if (reset <= password) {
      setShowPassword(reset);
    } else if (password !== reset) {
      setShowPassword("");
      return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = { username: login?.email, password: password }
    console.log(user);

    const res = authService.pathUrl('POST', '/auth/reset-password');
    const text = await authService.postAuth(res, user);
    setMessage(text?.Status);
    if (onSuccess) onSuccess();
  };

  return (
    <div style={{ maxWidth: "400px", margin: "auto" }}>
      {message && <Typography variant="body1" mt={1} textAlign={"center"} >{message}</Typography>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="New Password"
          type="password"
          title="Enter new password"
          value={password}
          margin="normal"
          fullWidth
          onChange={(e) => setPassword(e.target.value)}
          required
        // style={{ width: "100%", padding: "8px", margin: "5px 0" }}
        />

        <TextField
          label="Re-password"
          name="re-password"
          fullWidth
          variant="outlined"
          title="Re-Enter new password"
          type={showPassword ? 'password' : 'text'}
          value={showPassword}
          onChange={(e) => handleChange(e)}
          margin="normal"
          required
          sx={{ borderRadius: 2 }}

        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: 3,
            bgcolor: '#1b1914',
            fontWeight: 'bold',
            fontSize: '16px',
            paddingY: 1,
            borderRadius: 6,
            '&:hover': {
              backgroundColor: '#332a14ff',
            },
          }}
        >Reset Password</Button>
      </form>
    </div>
  );
}
